import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function JournalConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const aspectRatios = ["aspect-[4/5]", "aspect-square", "aspect-square"];
  const fallbackMeta = [{
    no: "12",
    category: "BERITA",
    time: "6 MENIT"
  }, {
    no: "11",
    category: "OPINI",
    time: "4 MENIT"
  }, {
    no: "10",
    category: "KEGIATAN",
    time: "8 MENIT"
  }];
  const fallbackImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/news_update_hero.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/news_update_hero.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/news_update_hero.png-wvc-sizes"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opinion_analysis_desk.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opinion_analysis_desk.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opinion_analysis_desk.webp-wvc-sizes"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/community_action_field.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/community_action_field.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/community_action_field.png-wvc-sizes"
  }];
  if (loading) {
    return <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="flex flex-col gap-5">
            <div className={`w-full ${aspectRatios[i]} bg-secondary animate-pulse`} />
            <div className="h-3 w-1/2 bg-secondary animate-pulse" />
            <div className="h-7 w-5/6 bg-secondary animate-pulse" />
            <div className="h-4 w-full bg-secondary animate-pulse" />
          </div>)}
      </div>;
  }
  if (error || posts.length === 0) {
    return <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        {fallbackMeta.map((meta, i) => <article data-index={i} key={i} className="group flex flex-col border border-border/30 bg-card transition-colors duration-300 hover:border-primary">
            <div className={`relative w-full overflow-hidden ${aspectRatios[i]}`}>
              <img src={fallbackImages[i].src} data-wvc-srcset={fallbackImages[i].srcset} data-wvc-sizes={fallbackImages[i].sizes} alt="Berita terkini organisasi" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
            </div>
            <div className="flex flex-1 flex-col gap-5 p-8">
              <div className="font-mono text-[0.6875rem] uppercase tracking-[0.18em] text-primary transition-transform duration-[250ms] ease-out group-hover:translate-x-1" style={{
            fontFamily: "var(--font-mono)"
          }}>
                {`Nº ${meta.no} · ${meta.category} · ${meta.time}`}
              </div>
              <h3 className="font-default text-2xl font-medium leading-[1.15] tracking-tight text-foreground md:text-[1.875rem]" style={{
            fontFamily: "var(--font-serif)"
          }}>
                Laporan utama kegiatan organisasi
              </h3>
              <p className="text-sm leading-[1.6] text-muted-foreground line-clamp-2">
                Informasi terkini mengenai pergerakan dan aksi nyata yang dilakukan oleh seluruh anggota di lapangan.
              </p>
              <div className="mt-2">
                <Link to="/NewsPage" className="group/link inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-primary" style={{
              fontFamily: "var(--font-mono)"
            }}>
                  <span className="relative">
                    Baca selengkapnya
                    <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[250ms] ease-out group-hover/link:w-full" />
                  </span>
                  <ArrowRight className="size-3" />
                </Link>
              </div>
            </div>
          </article>)}
      </div>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
      {displayPosts.map((post, i) => {
      const meta = fallbackMeta[i] || fallbackMeta[0];
      const categoryName = post.categories && post.categories.length > 0 ? post.categories[0].name : meta.category;
      return <article data-index={i} key={post.id} className="group flex flex-col border border-border/30 bg-card transition-colors duration-300 hover:border-primary">
            <div className={`relative w-full overflow-hidden ${aspectRatios[i] || "aspect-square"}`}>
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" /> : <img src={fallbackImages[i]?.src || fallbackImages[0].src} data-wvc-srcset={fallbackImages[i]?.srcset || fallbackImages[0].srcset} data-wvc-sizes={fallbackImages[i]?.sizes || fallbackImages[0].sizes} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />}
            </div>
            <div className="flex flex-1 flex-col gap-5 p-8">
              <div className="font-mono text-[0.6875rem] uppercase tracking-[0.18em] text-primary transition-transform duration-[250ms] ease-out group-hover:translate-x-1" style={{
            fontFamily: "var(--font-mono)"
          }}>
                {`Nº ${String(i + 10).padStart(2, "0")} · ${categoryName.toUpperCase()} · ${meta.time}`}
              </div>
              <h3 className="font-default text-2xl font-medium leading-[1.15] tracking-tight text-foreground md:text-[1.875rem]" style={{
            fontFamily: "var(--font-serif)"
          }}>
                {post.title}
              </h3>
              {post.excerpt && <p className="text-sm leading-[1.6] text-muted-foreground line-clamp-2" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}
              <div className="mt-2">
                <Link to={post.link || "#"} className="group/link inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-primary" style={{
              fontFamily: "var(--font-mono)"
            }}>
                  <span className="relative">
                    Baca selengkapnya
                    <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[250ms] ease-out group-hover/link:w-full" />
                  </span>
                  <ArrowRight className="size-3" />
                </Link>
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function Pagination() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="1215" id="pagination" className="bg-background text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-28 md:px-16 md:py-36 lg:px-24">
        {}
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-9">
            <div className="mb-8 font-mono text-xs uppercase tracking-[0.18em] text-primary" style={{
            fontFamily: "var(--font-mono)"
          }}>
              Nº 06 — Berita Terkini
            </div>
            <h2 className="font-default text-4xl font-normal leading-[1.04] tracking-tight text-foreground md:text-5xl lg:text-[3.75rem]" style={{
            fontFamily: "var(--font-serif)"
          }}>
              Kabar terbaru dari{" "}
              <em className="font-normal not-italic" style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              color: "var(--primary)"
            }}>
                organisasi
              </em>
              .
            </h2>
          </div>
          <div className="flex items-end md:col-span-3">
            <Link to="/NewsPage" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-foreground" style={{
            fontFamily: "var(--font-mono)"
          }}>
              <span className="relative">
                Lihat semua berita
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[250ms] ease-out group-hover:w-full" />
              </span>
              <ArrowRight className="size-3 transition-transform duration-[250ms] ease-out group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div className="relative my-12 flex items-center md:my-16">
          <span className="size-1 shrink-0 bg-primary" />
          <span className="h-px flex-1 bg-muted-foreground/40" />
          <span className="size-1 shrink-0 bg-primary" />
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <JournalConsumer />
        </PostsProvider>

        {}
        <div className="mt-12 flex md:hidden">
          <Link to="/NewsPage">
            <Button variant="default" className="rounded-md bg-primary px-7 py-3 font-default text-xs font-semibold uppercase tracking-[0.08em] text-primary-foreground hover:bg-primary/90">
              Lihat semua berita
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}